
// import React, { useEffect, useState } from 'react';
// import { useForm } from 'react-hook-form';
// import { useMutation, useQueryClient, useQuery } from 'react-query';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
// import { useNavigate } from 'react-router-dom';
// import { addSubcategory, updateSubcategory } from '../../../services/categoryApi';
// import { getSubcategoryById } from '../../../api/subcategory';
// import {
//   Box,
//   useToast,
//   Button,
//   FormControl,
//   FormLabel,
//   Input,
//   VStack,
//   FormErrorMessage,
//   Switch,
//   Image,
//   Text,
// } from '@chakra-ui/react';
// import Api from '../../../api/ApiUrl'

// // Adjust schema for optional image/file during update
// const schema = yup.object().shape({
//   name: yup.string().required('Name is required'),
//   description: yup.string().required('Description is required'),
//   deposit: yup.number().required('Deposit is required').min(0),
//   fileprice: yup.number().required('fileprice is required'),
//   startDate: yup.date().required('Start date is required'),
//   endDate: yup.date().required('End date is required'),

//   imagecover: yup.mixed().when('isUpdate', {
//     is: false,
//     then: yup.mixed().required('Image cover is required'),
//   }),
//   files: yup.mixed().when('isUpdate', {
//     is: false,
//     then: yup.mixed().required('File is required'),
//   }),
// });

// const SubcategoryForm = ({ subcategoryId, categoryId }) => {
//   const queryClient = useQueryClient();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [currentImage, setCurrentImage] = useState(null);
//   const [currentFile, setCurrentFile] = useState(null);

//   const { register, handleSubmit,watch, setValue, formState: { errors } } = useForm({
//     resolver: yupResolver(schema)
//   });

//   useQuery(['subcategory', subcategoryId], () => getSubcategoryById(subcategoryId), {
//     enabled: !!subcategoryId,
//     onSuccess: (data) => {
//       const subcategory = data.data;
//       setValue('name', subcategory.subcategory.name);
//       setValue('description', subcategory.subcategory.description);
//       setValue('deposit', subcategory.subcategory.deposit);
//       setValue('fileprice', subcategory.subcategory.fileprice);

//       setValue('startDate', subcategory.subcategory.startDate);
//       setValue('endDate', subcategory.subcategory.endDate);
//       setValue('seletedtoslider', subcategory.subcategory.seletedtoslider);
//       setCurrentImage(subcategory.subcategory.imagecover);
//       setCurrentFile(subcategory.subcategory.files);
//       setValue('isUpdate', true);
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message;
//       const errorsArray = error.response?.data?.errors;

//       if (errorsArray && Array.isArray(errorsArray)) {
//         errorsArray.forEach((err) => {
//           toast({
//             title: 'Error',
//             description: err.msg,
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//           });
//         });
//       } else if (errorMessage) {
//         toast({
//           title: 'Error',
//           description: errorMessage,
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     }
//   });

//   const mutation = useMutation(
//     subcategoryId ? (data) => updateSubcategory(subcategoryId, data) : (data) => addSubcategory(data),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('subcategories');
//         toast({
//           title: 'Success',
//           description: `Auctions ${subcategoryId ? 'updated' : 'created'} successfully`,
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         // console.log(`/dashboard/admin/categories/${categoryId}`)
//         // navigate(`/dashboard/admin/categories/${categoryId}`);
//         window.location.href = `/dashboard/admin/categories/${categoryId}`;
//       },
//       onError: (error) => {
//         const errorMessage = error.response?.data?.message;
//         const errorsArray = error.response?.data?.errors;

//         if (errorsArray && Array.isArray(errorsArray)) {
//           errorsArray.forEach((err) => {
//             toast({
//               title: 'Error',
//               description: err.msg,
//               status: 'error',
//               duration: 3000,
//               isClosable: true,
//             });
//           });
//         } else if (errorMessage) {
//           toast({
//             title: 'Error',
//             description: errorMessage,
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//           });
//         }
//       }
//     }
//   );

//   const onSubmit = (data) => {
//     const formData = new FormData();
//     formData.append('name', data.name);
//     formData.append('description', data.description);
//     formData.append('deposit', data.deposit);
//     formData.append('fileprice', data.fileprice);

//     formData.append('categoryId', categoryId);
//     formData.append('seletedtoslider', data.seletedtoslider);
//     formData.append('startDate', data.startDate);
//     formData.append('endDate', data.endDate);
//     if (data.imagecover && data.imagecover[0]) {
//       console.log(data.imagecover[0] ,data.files[0])
//       formData.append('imagecover', data.imagecover[0]);
//     }
//     if (data.files && data.files[0]) {
//       formData.append('files', data.files[0]);
//     }
//     mutation.mutate(formData);
//   };

//   return (
//     <Box p={5} shadow="md" borderWidth="1px" borderRadius="md">
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <VStack spacing={4}>
//           <FormControl isInvalid={errors.name}>
//             <FormLabel htmlFor="name">Name</FormLabel>
//             <Input id="name" {...register('name')} />
//             <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.description}>
//             <FormLabel htmlFor="description">Description</FormLabel>
//             <Input id="description" {...register('description')} />
//             <FormErrorMessage>{errors.description?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.deposit}>
//             <FormLabel htmlFor="deposit">Deposit</FormLabel>
//             <Input id="deposit" type="number" {...register('deposit')} />
//             <FormErrorMessage>{errors.deposit?.message}</FormErrorMessage>
//           </FormControl>
//           <FormControl isInvalid={errors.fileprice}>
//             <FormLabel htmlFor="deposit">file price</FormLabel>
//             <Input id="fileprice" type="number" {...register('fileprice')} />
//             <FormErrorMessage>{errors.fileprice?.message}</FormErrorMessage>
//           </FormControl>
//           {/* <FormControl isInvalid={errors.startDate}>
//             <FormLabel htmlFor="startDate">Start Date</FormLabel>
//             <Input type="datetime-local" id="startDate" {...register('startDate')} />
//             {errors.startDate && <Text color="red.500">{errors.startDate.message}</Text>}
//           </FormControl> */}
//               <FormControl isInvalid={errors.startDate}>
//                 <FormLabel htmlFor="startDate">Start Date</FormLabel>
//                 <Input type="datetime-local" id="startDate" {...register('startDate', {
//                   validate: (value) => new Date(value) > new Date() || 'Start Date cannot be in the past'
//                 })} />
//                   <FormErrorMessage>{errors.startDate?.message}</FormErrorMessage>
//           </FormControl> 

//               {/* <FormControl isInvalid={errors.endDate}>
//             <FormLabel htmlFor="endDate">End Date</FormLabel>
//             <Input type="datetime-local" id="endDate" {...register('endDate')} />
//             {errors.endDate && <Text color="red.500">{errors.endDate.message}</Text>}
//           </FormControl> */}
//           <FormControl isInvalid={errors.endDate}>
//                 <FormLabel htmlFor="endDate">End Date</FormLabel>
//                 <Input type="datetime-local" id="endDate" {...register('endDate', {
//                   validate: (value) => {
//                     const startDateValue = watch('startDate');
//                     return new Date(value) > new Date(startDateValue) || 'End Date must be after Start Date';
//                   }
//                 })} />
//                 <FormErrorMessage>{errors.endDate?.message}</FormErrorMessage>
//               </FormControl>
//           <FormControl mt="4">
//             <FormLabel htmlFor="seletedtoslider">Selected to Slider</FormLabel>
//             <Switch id="seletedtoslider" {...register('seletedtoslider')} />
//           </FormControl>

//           <FormControl isInvalid={errors.imagecover}>
//             <FormLabel htmlFor="imagecover">Image Cover</FormLabel>
//             <Input type="file" id="imagecover" {...register('imagecover')} />
//             {currentImage && (
//               <div>
//                 <Image src={`${Api}/${currentImage?.path}`} alt={currentImage.name} boxSize="150px" mt="4" />
//                 <p>Current Image: {currentImage.name}</p>
//               </div>
//             )}
//             <FormErrorMessage>{errors.imagecover?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.files}>
//             <FormLabel htmlFor="files">Files</FormLabel>
//             <Input type="file" id="files" {...register('files')} />
//             {currentFile && <p>Current File: {currentFile.name}</p>}
//             <FormErrorMessage>{errors.files?.message}</FormErrorMessage>
//           </FormControl>

//           <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
//             {subcategoryId ? 'Update' : 'Create'} Subcategory
//           </Button>
//         </VStack>
//       </form>
//     </Box>
//   );
// };

// export default SubcategoryForm;



// import React, { useEffect, useState } from 'react';
// import { useForm } from 'react-hook-form';
// import { useMutation, useQueryClient, useQuery } from 'react-query';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
// import { useNavigate } from 'react-router-dom';
// import { addSubcategory, updateSubcategory } from '../../../services/categoryApi';
// import { getSubcategoryById } from '../../../api/subcategory';
// import {
//   Box,
//   useToast,
//   Button,
//   FormControl,
//   FormLabel,
//   Input,
//   VStack,
//   FormErrorMessage,
//   Switch,
//   Image,
//   Text,
//   Checkbox,
//   CheckboxGroup,
//   Stack,
// } from '@chakra-ui/react';
// import Api from '../../../api/ApiUrl';

// // Adjust schema for optional image/file during update
// const schema = yup.object().shape({
//   name: yup.string().required('Name is required'),
//   description: yup.string().required('Description is required'),
//   deposit: yup.number().required('Deposit is required').min(0),
//   fileprice: yup.number().required('File price is required').min(0),
//   startDate: yup.date().required('Start date is required'),
//   endDate: yup.date().required('End date is required'),
//   paymentMethods: yup.array().of(yup.string()).required('At least one payment method is required'),
//   imagecover: yup.mixed().when('isUpdate', {
//     is: false,
//     then: yup.mixed().required('Image cover is required'),
//   }),
//   files: yup.mixed().when('isUpdate', {
//     is: false,
//     then: yup.mixed().required('File is required'),
//   }),
// });

// const SubcategoryForm = ({ subcategoryId, categoryId }) => {
//   const queryClient = useQueryClient();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [currentImage, setCurrentImage] = useState(null);
//   const [currentFile, setCurrentFile] = useState(null);

//   const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
//     resolver: yupResolver(schema)
//   });

//   useQuery(['subcategory', subcategoryId], () => getSubcategoryById(subcategoryId), {
//     enabled: !!subcategoryId,
//     onSuccess: (data) => {
//       const subcategory = data.data;
//       setValue('name', subcategory.subcategory.name);
//       setValue('description', subcategory.subcategory.description);
//       setValue('deposit', subcategory.subcategory.deposit);
//       setValue('fileprice', subcategory.subcategory.fileprice);
//       setValue('startDate', subcategory.subcategory.startDate);
//       setValue('endDate', subcategory.subcategory.endDate);
//       setValue('seletedtoslider', subcategory.subcategory.seletedtoslider);
//       setValue('paymentMethods', subcategory.subcategory.paymentMethods);
//       setCurrentImage(subcategory.subcategory.imagecover);
//       setCurrentFile(subcategory.subcategory.files);
//       setValue('isUpdate', true);
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message;
//       const errorsArray = error.response?.data?.errors;

//       if (errorsArray && Array.isArray(errorsArray)) {
//         errorsArray.forEach((err) => {
//           toast({
//             title: 'Error',
//             description: err.msg,
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//           });
//         });
//       } else if (errorMessage) {
//         toast({
//           title: 'Error',
//           description: errorMessage,
//           status: 'error',
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     }
//   });

//   const mutation = useMutation(
//     subcategoryId ? (data) => updateSubcategory(subcategoryId, data) : (data) => addSubcategory(data),
//     {
//       onSuccess: () => {
//         queryClient.invalidateQueries('subcategories');
//         toast({
//           title: 'Success',
//           description: `Auction ${subcategoryId ? 'updated' : 'created'} successfully`,
//           status: 'success',
//           duration: 3000,
//           isClosable: true,
//         });
//         window.location.href = `/dashboard/admin/categories/${categoryId}`;
//       },
//       onError: (error) => {
//         const errorMessage = error.response?.data?.message;
//         const errorsArray = error.response?.data?.errors;

//         if (errorsArray && Array.isArray(errorsArray)) {
//           errorsArray.forEach((err) => {
//             toast({
//               title: 'Error',
//               description: err.msg,
//               status: 'error',
//               duration: 3000,
//               isClosable: true,
//             });
//           });
//         } else if (errorMessage) {
//           toast({
//             title: 'Error',
//             description: errorMessage,
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//           });
//         }
//       }
//     }
//   );

//   const onSubmit = (data) => {
//     const formData = new FormData();
//     formData.append('name', data.name);
//     formData.append('description', data.description);
//     formData.append('deposit', data.deposit);
//     formData.append('fileprice', data.fileprice);
//     formData.append('categoryId', categoryId);
//     formData.append('seletedtoslider', data.seletedtoslider);
//     formData.append('startDate', data.startDate);
//     formData.append('endDate', data.endDate);
//     formData.append('paymentMethods', data.paymentMethods);
//     if (data.imagecover && data.imagecover[0]) {
//       formData.append('imagecover', data.imagecover[0]);
//     }
//     if (data.files && data.files[0]) {
//       formData.append('files', data.files[0]);
//     }
//     mutation.mutate(formData);
//   };

//   return (
//     <Box p={5} shadow="md" borderWidth="1px" borderRadius="md">
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <VStack spacing={4}>
//           <FormControl isInvalid={errors.name}>
//             <FormLabel htmlFor="name">Name</FormLabel>
//             <Input id="name" {...register('name')} />
//             <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.description}>
//             <FormLabel htmlFor="description">Description</FormLabel>
//             <Input id="description" {...register('description')} />
//             <FormErrorMessage>{errors.description?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.deposit}>
//             <FormLabel htmlFor="deposit">Deposit</FormLabel>
//             <Input id="deposit" type="number" {...register('deposit')} />
//             <FormErrorMessage>{errors.deposit?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.fileprice}>
//             <FormLabel htmlFor="fileprice">File Price</FormLabel>
//             <Input id="fileprice" type="number" {...register('fileprice')} />
//             <FormErrorMessage>{errors.fileprice?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.startDate}>
//             <FormLabel htmlFor="startDate">Start Date</FormLabel>
//             <Input type="datetime-local" id="startDate" {...register('startDate', {
//               validate: (value) => new Date(value) > new Date() || 'Start Date cannot be in the past'
//             })} />
//             <FormErrorMessage>{errors.startDate?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.endDate}>
//             <FormLabel htmlFor="endDate">End Date</FormLabel>
//             <Input type="datetime-local" id="endDate" {...register('endDate', {
//               validate: (value) => {
//                 const startDateValue = watch('startDate');
//                 return new Date(value) > new Date(startDateValue) || 'End Date must be after Start Date';
//               }
//             })} />
//             <FormErrorMessage>{errors.endDate?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl>
//             <FormLabel htmlFor="paymentMethods">Payment Methods</FormLabel>
//             <CheckboxGroup id="paymentMethods" {...register('paymentMethods')}>
//               <Stack spacing={4} direction="row">
//                 <Checkbox value="wallet">Wallet</Checkbox>
//                 <Checkbox value="fawry">Fawry</Checkbox>
//                 <Checkbox value="bank">Bank</Checkbox>
//               </Stack>
//             </CheckboxGroup>
//             <FormErrorMessage>{errors.paymentMethods?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl mt="4">
//             <FormLabel htmlFor="seletedtoslider">Selected to Slider</FormLabel>
//             <Switch id="seletedtoslider" {...register('seletedtoslider')} />
//           </FormControl>

//           <FormControl isInvalid={errors.imagecover}>
//             <FormLabel htmlFor="imagecover">Image Cover</FormLabel>
//             <Input type="file" id="imagecover" {...register('imagecover')} />
//             {currentImage && (
//               <div>
//                 <Image src={`${Api}/${currentImage?.path}`} alt={currentImage.name} boxSize="150px" mt="4" />
//                 <p>Current Image: {currentImage.name}</p>
//               </div>
//             )}
//             <FormErrorMessage>{errors.imagecover?.message}</FormErrorMessage>
//           </FormControl>

//           <FormControl isInvalid={errors.files}>
//             <FormLabel htmlFor="files">Files</FormLabel>
//             <Input type="file" id="files" {...register('files')} />
//             {currentFile && <p>Current File: {currentFile.name}</p>}
//             <FormErrorMessage>{errors.files?.message}</FormErrorMessage>
//           </FormControl>

//           <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
//             {subcategoryId ? 'Update' : 'Create'} Subcategory
//           </Button>
//         </VStack>
//       </form>
//     </Box>
//   );
// };

// export default SubcategoryForm;





import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useMutation, useQueryClient, useQuery } from 'react-query';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { addSubcategory, updateSubcategory } from '../../../services/categoryApi';
import { getSubcategoryById } from '../../../api/subcategory';
import {
  Box,
  useToast,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  FormErrorMessage,
  Switch,
  Image,
  Text,
  Checkbox,
  CheckboxGroup,
  Stack,
} from '@chakra-ui/react';
import Api from '../../../api/ApiUrl';

// Adjust schema for optional image/file during update
const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  description: yup.string().required('Description is required'),
  deposit: yup.number().required('Deposit is required').min(0),
  fileprice: yup.number().required('File price is required').min(0),
  startDate: yup.date().required('Start date is required'),
  endDate: yup.date().required('End date is required'),
  paymentMethods: yup.array().of(
    yup.object().shape({
      name: yup.string().required('Payment method is required'),
      // details: yup.string().required('Details are required')
    })
  ).required('At least one payment method is required'),
  imagecover: yup.mixed().when('isUpdate', {
    is: false,
    then: yup.mixed().required('Image cover is required'),
  }),
  files: yup.mixed().when('isUpdate', {
    is: false,
    then: yup.mixed().required('File is required'),
  }),
});

const SubcategoryForm = ({ subcategoryId, categoryId }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const toast = useToast();
  const [currentImage, setCurrentImage] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);

  const { register, handleSubmit, watch, setValue, control, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  useQuery(['subcategory', subcategoryId], () => getSubcategoryById(subcategoryId), {
    enabled: !!subcategoryId,
    onSuccess: (data) => {
      const subcategory = data.data.subcategory;
      setValue('name', subcategory.name);
      setValue('description', subcategory.description);
      setValue('deposit', subcategory.deposit);
      setValue('fileprice', subcategory.fileprice);
      setValue('startDate', subcategory.startDate);
      setValue('endDate', subcategory.endDate);
      setValue('seletedtoslider', subcategory.seletedtoslider);
      setValue('paymentMethods', subcategory.paymentMethods);
      setCurrentImage(subcategory.imagecover);
      setCurrentFile(subcategory.files);
      setValue('isUpdate', true);
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message;
      const errorsArray = error.response?.data?.errors;

      if (errorsArray && Array.isArray(errorsArray)) {
        errorsArray.forEach((err) => {
          toast({
            title: 'Error',
            description: err.msg,
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        });
      } else if (errorMessage) {
        toast({
          title: 'Error',
          description: errorMessage,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  });

  const mutation = useMutation(
    subcategoryId ? (data) => updateSubcategory(subcategoryId, data) : (data) => addSubcategory(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('subcategories');
        toast({
          title: 'Success',
          description: `Auction ${subcategoryId ? 'updated' : 'created'} successfully`,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        window.location.href = `/dashboard/admin/categories/${categoryId}`;
      },
      onError: (error) => {
        const errorMessage = error.response?.data?.message;
        const errorsArray = error.response?.data?.errors;

        if (errorsArray && Array.isArray(errorsArray)) {
          errorsArray.forEach((err) => {
            toast({
              title: 'Error',
              description: err.msg,
              status: 'error',
              duration: 3000,
              isClosable: true,
            });
          });
        } else if (errorMessage) {
          toast({
            title: 'Error',
            description: errorMessage,
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      }
    }
  );

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('deposit', data.deposit);
    formData.append('fileprice', data.fileprice);
    formData.append('categoryId', categoryId);
    formData.append('seletedtoslider', data.seletedtoslider ? 'true' : 'false'); 
    formData.append('startDate', data.startDate);
    formData.append('endDate', data.endDate);
    // Correctly append the array of objects without stringifying
    data.paymentMethods.forEach((paymentMethod, index) => {
      formData.append(`paymentMethods[${index}][name]`, paymentMethod.name);
      formData.append(`paymentMethods[${index}][details]`, paymentMethod.details);
    });
    if (data.imagecover && data.imagecover[0]) {
      formData.append('imagecover', data.imagecover[0]);
    }
    if (data.files && data.files[0]) {
      formData.append('files', data.files[0]);
    }
    mutation.mutate(formData);
  };
  
  return (
    <Box p={5} shadow="md" borderWidth="1px" borderRadius="md">
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={4}>
          <FormControl isInvalid={errors.name}>
            <FormLabel htmlFor="name">Name</FormLabel>
            <Input id="name" {...register('name')} />
            <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.description}>
            <FormLabel htmlFor="description">Description</FormLabel>
            <Input id="description" {...register('description')} />
            <FormErrorMessage>{errors.description?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.deposit}>
            <FormLabel htmlFor="deposit">Deposit</FormLabel>
            <Input id="deposit" type="number" {...register('deposit')} />
            <FormErrorMessage>{errors.deposit?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.fileprice}>
            <FormLabel htmlFor="fileprice">File Price</FormLabel>
            <Input id="fileprice" type="number" {...register('fileprice')} />
            <FormErrorMessage>{errors.fileprice?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.startDate}>
            <FormLabel htmlFor="startDate">Start Date</FormLabel>
            <Input type="datetime-local" id="startDate" {...register('startDate', {
              validate: (value) => new Date(value) > new Date() || 'Start Date cannot be in the past'
            })} />
            <FormErrorMessage>{errors.startDate?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.endDate}>
            <FormLabel htmlFor="endDate">End Date</FormLabel>
            <Input type="datetime-local" id="endDate" {...register('endDate', {
              validate: (value) => {
                const startDateValue = watch('startDate');
                return new Date(value) > new Date(startDateValue) || 'End Date must be after Start Date';
              }
            })} />
            <FormErrorMessage>{errors.endDate?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.paymentMethods}>
            <FormLabel htmlFor="paymentMethods">Payment Methods</FormLabel>
            <VStack spacing={2}>
              <Controller
                control={control}
                name="paymentMethods"
                defaultValue={[]}
                render={({ field: { onChange, value } }) => (
                  <>
                    <Stack direction="row">
                    <Checkbox
                        value="mobile"
                        isChecked={value.some(pm => pm.name === 'mobile')}
                        onChange={e => {
                          const checked = e.target.checked;
                          onChange(
                            checked
                            ? [...value, { name: 'mobile', details: '' }]
                            : value.filter(pm => pm.name !== 'mobile')
                          );
                        }}
                      >
                        Mobile
                      </Checkbox>
                      <Checkbox
                        value="wallet"
                        isChecked={value.some(pm => pm.name === 'wallet')}
                        onChange={e => {
                          const checked = e.target.checked;
                          onChange(
                            checked
                            ? [...value, { name: 'wallet', details: '' }]
                            : value.filter(pm => pm.name !== 'wallet')
                          );
                        }}
                      >
                        Wallet
                      </Checkbox>
                      <Checkbox
                        value="instapay"
                        isChecked={value.some(pm => pm.name === 'instapay')}
                        onChange={e => {
                          const checked = e.target.checked;
                          onChange(
                            checked
                            ? [...value, { name: 'instapay', details: '' }]
                            : value.filter(pm => pm.name !== 'instapay')
                          );
                        }}
                      >
                        instapay
                      </Checkbox>
                      <Checkbox
                        value="fawry"
                        isChecked={value.some(pm => pm.name === 'fawry')}
                        onChange={e => {
                          const checked = e.target.checked;
                          onChange(
                            checked
                            ? [...value, { name: 'fawry', details: '' }]
                            : value.filter(pm => pm.name !== 'fawry')
                          );
                        }}
                      >
                        Fawry
                      </Checkbox>
                      <Checkbox
                        value="bank"
                        isChecked={value.some(pm => pm.name === 'bank')}
                        onChange={e => {
                          const checked = e.target.checked;
                          onChange(
                            checked
                            ? [...value, { name: 'bank', details: '' }]
                            : value.filter(pm => pm.name !== 'bank')
                          );
                        }}
                      >
                        Bank
                      </Checkbox>
                    </Stack>
                    {/* {value.map((pm, index) => (
                      <FormControl key={index} isInvalid={errors.paymentMethods?.[index]?.details}>
                        <FormLabel htmlFor={`details-${pm.name}`}>Details for {pm.name}</FormLabel>
                        <Input
                          id={`details-${pm.name}`}
                          value={pm.details}
                          onChange={e => {
                            const newValue = [...value];
                            newValue[index].details = e.target.value;
                            onChange(newValue);
                          }}
                        />
                        <FormErrorMessage>{errors.paymentMethods?.[index]?.details?.message}</FormErrorMessage>
                      </FormControl>
                    ))} */}
                  </>
                )}
              />
            </VStack>
            <FormErrorMessage>{errors.paymentMethods?.message}</FormErrorMessage>
          </FormControl>

          <FormControl mt="4">
  <FormLabel htmlFor="seletedtoslider">Selected to Slider</FormLabel>
  <Controller
    control={control}
    name="seletedtoslider"
    defaultValue={false}  // Ensure the default value is set to false
    render={({ field: { onChange, value } }) => (
      <Switch
        id="seletedtoslider"
        isChecked={!!value}  // Ensure the value is treated as a Boolean
        onChange={(e) => onChange(e.target.checked)}  // Set the Boolean value
      />
    )}
  />
</FormControl>


          <FormControl isInvalid={errors.imagecover}>
            <FormLabel htmlFor="imagecover">Image Cover</FormLabel>
            <Input type="file" id="imagecover" {...register('imagecover')} />
            {currentImage && (
              <div>
                <Image src={`${Api}/${currentImage?.path}`} alt={currentImage.name} boxSize="150px" mt="4" />
                <p>Current Image: {currentImage.name}</p>
              </div>
            )}
            <FormErrorMessage>{errors.imagecover?.message}</FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.files}>
            <FormLabel htmlFor="files">Files</FormLabel>
            <Input type="file" id="files" {...register('files')} />
            {currentFile && <p>Current File: {currentFile.name}</p>}
            <FormErrorMessage>{errors.files?.message}</FormErrorMessage>
          </FormControl>

          <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
            {subcategoryId ? 'Update' : 'Create'} Subcategory
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default SubcategoryForm;
